import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export function extractBotResponse(response: any): string {
  if (typeof response === 'string') return response;

  for (const key of ['reply', 'message', 'data?.message', 'answer', 'response', 'text']) {
    const value = key.split('?.').reduce((obj, segment) => obj?.[segment], response);
    if (typeof value === 'string') return value;
  }

  if (response && typeof response === 'object') {
    const stringValue = Object.values(response).find((value) => typeof value === 'string');
    if (stringValue) return stringValue as string;
  }

  return JSON.stringify(response);
}

export function parseBotResponse(
  response: string,
  sanitizer: DomSanitizer
): { html?: SafeHtml; tableData?: any[] } {
  const parser = new DOMParser();

  if (response.trim().startsWith('[{')) {
    try {
      const parsedArray = JSON.parse(response);
      if (Array.isArray(parsedArray)) {
        return { tableData: parsedArray };
      }
    } catch { }
  }

  if (response.trim().startsWith('{')) {
    try {
      const parsedObject = JSON.parse(response);
      let html = '<table border="1"><tr><th>Key</th><th>Value</th></tr>';

      for (const key in parsedObject) {
        html += `<tr><td>${key}</td><td>${parsedObject[key]}</td></tr>`;
      }

      html += '</table>';
      return { html: sanitizer.bypassSecurityTrustHtml(html) };
    } catch { }
  }

  if (response.includes('<') && response.includes('>')) {
    const parsedDocument = parser.parseFromString(response, 'text/html');
    return { html: sanitizer.bypassSecurityTrustHtml(parsedDocument.body.innerHTML) };
  }

  return { html: undefined };
}

export function formatTimer(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${padZero(minutes)}: ${padZero(remainingSeconds)}`;
}

function padZero(value: number): string {
  return value < 10 ? `0${value}` : `${value}`;
}
